export interface SocialMediaValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateSocialMediaUrl = (platform: string, url: string): SocialMediaValidationResult => {
  if (!url.trim()) {
    return { isValid: true }; // Empty URLs are valid (optional fields)
  }

  // Basic URL format check
  try {
    new URL(url);
  } catch {
    return {
      isValid: false,
      error: 'Please enter a valid URL starting with http:// or https://'
    };
  }

  const normalizedUrl = url.toLowerCase();

  switch (platform) {
    case 'facebook':
      if (!normalizedUrl.includes('facebook.com') && !normalizedUrl.includes('fb.com')) {
        return {
          isValid: false,
          error: 'Please enter a valid Facebook URL (facebook.com or fb.com)'
        };
      }
      break;

    case 'instagram':
      if (!normalizedUrl.includes('instagram.com')) {
        return {
          isValid: false,
          error: 'Please enter a valid Instagram URL (instagram.com)'
        };
      }
      break;

    case 'youtube':
      if (!normalizedUrl.includes('youtube.com') && !normalizedUrl.includes('youtu.be')) {
        return {
          isValid: false,
          error: 'Please enter a valid YouTube URL (youtube.com or youtu.be)'
        };
      }
      break;

    case 'tiktok':
      if (!normalizedUrl.includes('tiktok.com')) {
        return {
          isValid: false,
          error: 'Please enter a valid TikTok URL (tiktok.com)'
        };
      }
      break;

    case 'website':
      // For general websites, just check it's a valid URL (already done above)
      break;

    default:
      return {
        isValid: false,
        error: 'Unknown social media platform'
      };
  }

  return { isValid: true };
};

export const validateAllSocialLinks = (socialLinks: Record<string, string>): Record<string, SocialMediaValidationResult> => {
  const results: Record<string, SocialMediaValidationResult> = {};

  Object.entries(socialLinks).forEach(([platform, url]) => {
    results[platform] = validateSocialMediaUrl(platform, url);
  });

  return results;
};